import { AfterViewChecked, ChangeDetectorRef, Component } from '@angular/core';

@Component({
  selector: 'app-extension-list',
  templateUrl: './extension-list.component.html',
  styleUrls: ['./extension-list.component.scss']
})
export class ExtensionListComponent implements AfterViewChecked
{

  public total: number;

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  public ngAfterViewChecked(): void
  {
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Output Event handler to set the loaded number of assessments in the header.
   *
   * @param count Number of assessment loaded.
   */
  public setTotal(count: number): void
  {
    this.total = count !== undefined ? count : 0;
  }

}
